import * as suuid from 'short-uuid';
function stripFQN(actionName) {
    if (actionName.includes('@')) {
        // type is FQN, of form <namespace>/<package>/<name>@version
        return actionName.split('/')[2].split('@')[0];
    }
    else {
        // type is a legacy action
        return actionName;
    }
}
/**
 * Generates a unique name with an suuid given an [actionName]
 * @param actionName Must be of the form <namespace>/<package>/<name>[@]version OR <name>
 */
export const generateResultUniqueName = (actionName) => {
    return `${stripFQN(actionName)}Result_${suuid.generate()}`;
};
//# sourceMappingURL=resultUniqueName.js.map